export default "__VITE_ASSET__D_W6Jpkf__"